import { data as authTranslations } from './data-auth.ts';
import { data as billingTranslations } from './data-billing.ts';
import { data as brandContextTranslations } from './data-brand-context.ts';
import { data as componentsTranslations } from './data-components.ts';
import { data as errorsTranslations } from './data-errors.ts';
import { data as globalTranslations } from './data-global.ts';
import { data as productsTranslations } from './data-products.ts';
import { data as loadingTranslations } from './data-screen.ts';
import { data as settingsTranslations } from './data-settings.ts';
import { data as dataTranslations } from './data.ts';
import { type TranslationDataObj } from './type.ts';

export const data: TranslationDataObj = {
  ...authTranslations,
  ...billingTranslations,
  ...errorsTranslations,
  ...dataTranslations,
  ...globalTranslations,
  ...settingsTranslations,
  ...loadingTranslations,
  ...productsTranslations,
  ...brandContextTranslations,
  ...componentsTranslations,
};
